/**
 * Leave the browser's Fullscreen API mode if the page is in it. Used when a
 * viewer leaves immersive mode by double tap: the header button may have
 * requested fullscreen on the way in, and hiding the chrome alone would leave
 * the browser stuck full screen. A rejection is logged, never thrown — the
 * viewer has already left immersive mode.
 */
export function exitBrowserFullscreen(): void {
	if (!globalThis.document?.fullscreenElement) return
	try {
		globalThis.document.exitFullscreen?.()?.catch(console.warn)
	} catch (err) {
		console.warn('[exitBrowserFullscreen] exit refused:', err)
	}
}
